export const ADMIN_ROLES = ['user', 'support', 'admin', 'editor', 'ad_manager', 'ad_lead'];
const ROLE_SET = new Set(ADMIN_ROLES);
const ROLE_LABELS = {
    user: 'Пользователь',
    support: 'Поддержка',
    admin: 'Администратор',
    editor: 'Редактор',
    ad_manager: 'Менеджер рекламы',
    ad_lead: 'Главный рекламщик',
};
const DEFAULT_PATHS = {
    admin: '/opengater/users',
    support: '/opengater/users',
    editor: '/opengater/news',
    ad_manager: '/opengater/events',
    ad_lead: '/opengater/events',
};
/** Unknown future roles are deliberately denied until the panel understands them. */
export function normalizeRole(value) {
    return typeof value === 'string' && ROLE_SET.has(value) ? value : null;
}
export function roleLabel(role) {
    const known = normalizeRole(role);
    return known ? ROLE_LABELS[known] : String(role);
}
/** Explicit allowlist check. This is the primary access primitive. */
export function roleCan(role, allowed) {
    return role !== null && allowed.includes(role);
}
/** Compatibility for existing admin/support controls; specialist roles stay outside the ladder. */
export function minimumRoleAllows(role, minimum) {
    if (role === null || role === 'editor' || role === 'ad_manager' || role === 'ad_lead') {
        return false;
    }
    if (minimum === 'user')
        return true;
    if (minimum === 'support')
        return role === 'support' || role === 'admin';
    return role === 'admin';
}
export function defaultPathForRole(role) {
    return role === null ? null : (DEFAULT_PATHS[role] ?? null);
}
